
    <!--
 * 竖版-全局弹窗
 * @LastEditTime: Wed Dec 18 2024 22:40:11 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_2BPC42"  :class="[`normal`,`u_c_2BPC42`]" ><div id="u_c_YJD823"  v-show="compData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup`,`u_c_YJD823`]" ><div id="u_c_IQ1I17"  :class="[`normal popup-content-small`,`u_c_IQ1I17`]" @click="u_c_IQ1I17_event_3TKR35($event)"><div id="u_c_EY7P18"  :class="[`normal popup-title commonColor`,`u_c_EY7P18`]" >{{`${ langData.bindTitle }`}}</div><div id="u_c_KR2M19"  :class="[`normal`,`u_c_KR2M19`]" ><div id="u_c_HZBH20"  :class="[`normal select-item`,`u_c_HZBH20`]" ><select id="u_c_3SEO21"  v-model="pageData.serverItem" :class="[`normal select-item-select commonColor`,`u_c_3SEO21`]" ><option id="u_c_Q6EH17" disabled="disabled" :value="defaultServerItem" :class="[`normal`,`u_c_Q6EH17`]" >{{`${ langData.selectServer }`}}</option><optgroup id="u_c_U10T18"  :label="langData.yourServer" :class="[`normal commonColor`,`u_c_U10T18`]" ><option id="u_c_YZGP19"  v-for="(sItem, sIndex) in pageData.recentServerList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_YZGP19`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_X49T20"  :label="langData.allServer" :class="[`normal`,`u_c_X49T20`]" ><option id="u_c_ZAYG21"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_ZAYG21`]" >{{`${ sItem.sname }`}}</option></optgroup></select></div><div id="u_c_5SI923"  :class="[`normal select-item`,`u_c_5SI923`]" ><select id="u_c_2Y8024"  v-model="pageData.roleIndex" :class="[`normal select-item-select commonColor`,`u_c_2Y8024`]" ><option id="u_c_330T25"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal`,`u_c_330T25`]" >{{`${ rItem.roleName }`}}</option></select></div></div><a id="u_c_6GFC37" href="javascript:;" :class="[`normal btn-txt btn-bg commonFont`,`u_c_6GFC37`]" @click="u_c_6GFC37_event_8CVK38($event)">{{`${ langData.sure }`}}</a><a id="u_c_TV8F38" href="javascript:;" :class="[`normal popup-close`,`u_c_TV8F38`]" @click="u_c_TV8F38_event_7ICN37($event)"></a></div></div><div id="u_c_KN8R26"  v-show="compData.previewPopup == 'bag' || pageData.bagPopupState" :class="[`normal popup`,`u_c_KN8R26`]" @click="u_c_KN8R26_event_TA3042($event)"><div id="u_c_HQCT47"  :class="[`normal popup-content-small`,`u_c_HQCT47`]" ><div id="u_c_448359"  :class="[`normal popup-title commonColor`,`u_c_448359`]" >{{`${ langData.myPackage }`}}</div><div id="u_c_YEB860"  :class="[`normal border-color`,`u_c_YEB860`]" ><table id="u_c_4G5M63"  :class="[`normal`,`u_c_4G5M63`]" ><thead id="u_c_0KSB65"  :class="[`normal`,`u_c_0KSB65`]" ><td id="u_c_TG2X67"  :class="[`normal th border-color txt-size commonColor commonFont`,`u_c_TG2X67`]" >{{`${ langData.packageTime }`}}</td><td id="u_c_UBST68"  :class="[`normal th border-color txt-size commonColor commonFont`,`u_c_UBST68`]" >{{`${ langData.packageName }`}}</td></thead><tbody id="u_c_SQDF66"  :class="[`normal`,`u_c_SQDF66`]" ><tr id="u_c_8TD969"  v-for="(packItem, pI) in pageData.myPackageList" :key="pI" :class="[`normal border-color tr commonColor commonFont`,`u_c_8TD969`]" ><td id="u_c_ZEPA70"  :class="[`normal td border-color txt-size commonFont`,`u_c_ZEPA70`]" >{{`${ packItem.create_time }`}}</td><td id="u_c_ER8H71"  :class="[`normal td border-color txt-size commonFont`,`u_c_ER8H71`]" >{{`${ packItem.send_value || packItem.name }`}}</td></tr></tbody></table><div id="u_c_78XI64"  v-html="langData.noBag" v-show="!pageData.myPackageList.length" :class="[`normal commonFont commonColor`,`u_c_78XI64`]" ></div></div><a id="u_c_TIZH62" href="javascript:;" :class="[`normal popup-close`,`u_c_TIZH62`]" @click="u_c_TIZH62_event_E34734($event)"></a></div></div><div id="u_c_AFSS32"  v-show="compData.previewPopup == 'info' || pageData.infoPopupState" :class="[`normal popup`,`u_c_AFSS32`]" ><div id="u_c_UBPO43"  :class="[`normal popup-content-small`,`u_c_UBPO43`]" ><div id="u_c_M1B344"  :class="[`normal popup-title commonColor`,`u_c_M1B344`]" >{{`${ langData.infoBtn }`}}</div><div id="u_c_G0FY45"  v-html="compData.infoContent" :class="[`normal commonFont commonColor`,`u_c_G0FY45`]" ></div><a id="u_c_3ZQY56" href="javascript:;" :class="[`normal popup-close`,`u_c_3ZQY56`]" @click="u_c_3ZQY56_event_IH4L41($event)"></a></div></div><div id="u_c_C3H233"  v-show="compData.previewPopup == 'tips' || pageData.tipsPopupState" :class="[`normal popup`,`u_c_C3H233`]" ><div id="u_c_OX6L51"  :class="[`normal popup-content-small`,`u_c_OX6L51`]" ><div id="u_c_C2JU42"  :class="[`normal commonFont commonColor`,`u_c_C2JU42`]" >{{`${ pageData.tips }`}}</div><a id="u_c_7C4L52" href="javascript:;" :class="[`normal btn-txt btn-bg commonFont`,`u_c_7C4L52`]" @click="u_c_7C4L52_event_8EVX35($event)">{{`${ langData.sure }`}}</a><a id="u_c_1UF454" href="javascript:;" :class="[`normal popup-close`,`u_c_1UF454`]" @click="u_c_1UF454_event_AXKN36($event)"></a></div></div><div id="u_c_MMYF34"  v-show="compData.previewPopup == 'gift' || pageData.awardContentPopupState" :class="[`normal popup`,`u_c_MMYF34`]" ><div id="u_c_P0BR79"  :class="[`normal popup-content-small`,`u_c_P0BR79`]" ><div id="u_c_OXL080"  v-html="pageData.awardDetail" :class="[`normal commonFont commonColor`,`u_c_OXL080`]" ></div><a id="u_c_Z9F820" href="javascript:;" :class="[`normal btn-txt btn-bg commonFont`,`u_c_Z9F820`]" @click="u_c_Z9F820_event_XJ4L23($event)">{{`${ langData.sure }`}}</a><a id="u_c_PNO584" href="javascript:;" :class="[`normal popup-close`,`u_c_PNO584`]" @click="u_c_PNO584_event_4DBR19($event)"></a></div></div><div id="u_c_31P119"  v-show="compData.previewPopup == 'xuhao' || pageData.giftCodePopupState" :class="[`normal popup`,`u_c_31P119`]" ><div id="u_c_W90O20"  :class="[`normal popup-content-small`,`u_c_W90O20`]" ><div id="u_c_15RV21"  :class="[`normal popup-title commonColor`,`u_c_15RV21`]" >{{`${ langData.giftCodeTitle }`}}</div><div id="u_c_X5YO22"  :class="[`normal`,`u_c_X5YO22`]" ><div id="u_c_YUS223"  :class="[`normal commonFont commonColor`,`u_c_YUS223`]" >{{`${ langData.giftCode }:${ pageData.nowGiftCode }`}}</div><a id="u_c_BG7F24" href="javascript:;" :class="[`normal btn-txt commonFont commonColor`,`u_c_BG7F24`]" @click="u_c_BG7F24_event_L22Q23($event)">{{`${ langData.copy }`}}</a></div><div id="u_c_W7PW25"  v-show="compData.copyTipsState" :class="[`normal commonFont commonColor`,`u_c_W7PW25`]" >{{`${ langData.copySucc }`}}</div><a id="u_c_1UN127" href="javascript:;" :class="[`normal btn-txt btn-bg commonFont`,`u_c_1UN127`]" @click="u_c_1UN127_event_40NO17($event)">{{`${ langData.goChange }`}}</a><a id="u_c_W8MW21" href="javascript:;" :class="[`normal popup-close`,`u_c_W8MW21`]" @click="u_c_W8MW21_event_AXKN36($event)"></a></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"infoContent":`1. 本活动长期有效；
2. 在游戏：商人放浪记中使用第三方充值渠道进行充值，达到一定金额，即可获得对应充值金额的礼包奖励；
3.累计充值活动分为每日累充以及终身累充两种类型；
每日累充
（1）當天累計儲值金額達到以下檔位，可获得对应的奖励，每日每个礼包仅可以领取一次：19999、39999、119999、199999、399999、799999、1999999
（2）每日0點將重置累計金額數值，次日可重新参与每日累充活动；

终身累充
（1）充值达到一定金额，即可获得对应的礼包奖励，每个礼包只可获得一次；
（2）累计充值为终身累计方式，不会过期；
4. 累计充值计算和礼包领取以游戏角色为单位，请先绑定角色；
5. 最终解释权归37games所有。`,"copyTipsState":true,"exchangeLink":`https://gevents.blancozone.com/globalexchange/index.html`,"previewPopup":``},"zh-TW":{"infoContent":`活動規則：
1. 本活動在活動期內有效；
2. 在遊戲【小妖问道】中使用協力廠商儲值管道進行儲值，達到一定金額，即可獲得對應儲值金額的禮包獎勵；
3.累計儲值活動分為每日累儲以及活動累儲兩種類型：

每日累儲
（1）當天累計儲值金額達到以下檔位（台幣），可獲得對應的獎勵，每日每個禮包僅可以領取一次：1500、3000、5000、8000、10000、20000。
（2）每日0點將重置累計金額數值，次日可重新參與每日累儲活動；
（3）未及時領取每日累儲獎勵，不予補發。請各位道友記得及時領取。

活動累儲
（1）儲值達到一定金額，即可獲得對應的禮包獎勵，每個禮包只可獲得一次；
（2）累計儲值統計為活動開啟期間累計金額；

4. 累計儲值計算和禮包領取以遊戲帐号為單位，請先登錄帳號；
5. 登錄賬號後需綁定遊戲角色，目前只支持綁定1個角色，並且無法解綁。
6. 本次活動的最終解釋權歸《小妖问道》运营团队所有。`,"copyTipsState":true,"exchangeLink":`https://gevents.blancozone.com/globalexchange/index.html`,"previewPopup":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '全局弹窗';

    // 自定义setup - 开始
    const { toClipboard } = useClipboard();
const showTips = inject("showTips", (txt) => {});
const initActivity = inject("initActivity", () => {})
const defaultServerItem = [
  {sid: "", id: "", sname: getLangTxt("pleaseSelectServer")},
]
const defaultRoleItem = [
  { roleID: "", roleName: getLangTxt("selectRole") },
];
const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global";

compData.previewPopup = "";
compData.bindPopupState = false;
compData.bagPopupState = false;
compData.infoPopupState = false;
compData.tipsPopupState = false;
compData.giftCodePopupState = false;
compData.awardContentPopupState = false;
compData.copyTipsState = false;
pageData.serverList = _.cloneDeep(defaultServerItem);
pageData.serverItem = _.cloneDeep(defaultServerItem);
pageData.roleList = _.cloneDeep(defaultRoleItem);
compData.exchangeLink = utils.updateLinkParams(compData.exchangeLink,{
  gameId:pageData.gameId,
  language:curLang,
  cid:'activity',
  scid:pageData.pageId
})


watch(
  () => pageData.isLogin,
  async (value) => {
    if (!value) return
    await initServerList()
    initLinkServer()
  }
)

watch(
  () => pageData.serverItem,
  async (value) => {
    if (!value) return
    await initRoleList()
    initLinkRole()
  }
)
const initServerList = async () => {
  pageData.serverList = []
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=listServerNew`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=listServerNew`,
    jp:`https://jpeventsapi.37games.com/activity/execute?name=${pageData.pageId}&action=listServerNew`
  }
  let res = await request.getJSON(link[pagePlatform])
  if (res.result == 1) {
    res?.data?.all_servers
      && pageData.serverList.push(...res.data.all_servers);
    res?.data?.recent_servers
      && pageData.recentServerList.push(...res.data.recent_servers);
  }
}

const initRoleList = async () => {
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getMobileGameRole`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=getMobileGameRole`,
    jp:`https://jpeventsapi.37games.com/activity/execute?name=${pageData.pageId}&action=getMobileGameRole`
  }
  let res = await request.getJSON(link[pagePlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
    }),
  })
  if (res.result == 1) {
    pageData.roleList.push(...res.data)
    if (res.data.length == 1) {
      pageData.roleIndex = 1
    }
  }
}

const initLinkServer = () => {
  let linkParam =
    utils.getUrlParams("serverId") ||
    utils.getUrlParams("server_id") ||
    utils.getUrlParams("serverID")
  let _index = 0
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.serverItem = pageData.serverList[_index];
  }
}

const initLinkRole = () => {
  let linkParam =
    utils.getUrlParams("roleId") || utils.getUrlParams("roleID")
  let _index = 0
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.roleIndex = _index
  }
}

const canClickBindSubmit = ref(true)
const bindRole = async () => {
  const link = {
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=bind`,
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=bind`,
    jp:`https://jpeventsapi.37games.com/activity/execute?name=${pageData.pageId}&action=bind`
  }
  let res = await request.getJSON(link[pagePlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
      server_sid: pageData.serverItem.id,
      s_id: pageData.serverItem.id,
      role_id: pageData.roleList[pageData.roleIndex].roleID,
      role_name: encodeURIComponent(encodeURIComponent(pageData.roleList[pageData.roleIndex].roleName)),
      server_name: pageData.serverItem.sname,
      language:curLang
    }),
  })
  if (res.result == 1) {
    pageData.serverName = pageData.serverItem.sname
    pageData.roleName = pageData.roleList[pageData.roleIndex].roleName
    pageData.bindPopupState = false
    pageData.isBind = true
    initActivity()
  } else {
    showTips(getLangTxt(res.code, `${getLangTxt("common")}[${res.code}]`));
  }
};
      // 弹窗内容的click事件
      const u_c_IQ1I17_event_3TKR35= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认绑定的click事件
      const u_c_6GFC37_event_8CVK38= async (e)=>{
        try {if (!pageData.serverItem || !pageData.serverItem.sid) {
          alert(getLangTxt("selectServer"))
          return
        }
        if (!pageData.roleIndex) {
          alert(getLangTxt("selectRole"))
          return
        }
        if (!canClickBindSubmit.value) return
        canClickBindSubmit.value = false
        await bindRole()
        canClickBindSubmit.value = true} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_TV8F38_event_7ICN37= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗的click事件
      const u_c_KN8R26_event_TA3042= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_TIZH62_event_E34734= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_3ZQY56_event_IH4L41= async (e)=>{
        try {pageData.infoPopupState = false} catch (error) {console.log(error)}
      };
      // 确认的click事件
      const u_c_7C4L52_event_8EVX35= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_1UF454_event_AXKN36= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 确认的click事件
      const u_c_Z9F820_event_XJ4L23= async (e)=>{
        try {pageData.awardContentPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_PNO584_event_4DBR19= async (e)=>{
        try {pageData.awardContentPopupState = false} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_BG7F24_event_L22Q23= async (e)=>{
        try {try{
 window.dataLayer.push({
    event: "trackEvent",
    eventName:"custom_popup_window",
    eventKey:"copy",
    type:"click"
  });
}catch(e){}
await toClipboard(pageData.nowGiftCode);
compData.copyTipsState = true;} catch (error) {console.log(error)}
      };
      // 前往兑奖按钮的click事件
      const u_c_1UN127_event_40NO17= async (e)=>{
        try {window.open(compData.exchangeLink,"_self")
} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_W8MW21_event_AXKN36= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_2BPC42.normal{
position:relative;

}

.u_c_2BPC42.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_2BPC42.normal .popup-content-small{
width:9.24rem;
height:7.13rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907467567971.png);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;
background-size:100% 100%;

}

.u_c_2BPC42.normal .popup-close{
width:0.67rem;
height:0.67rem;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907481944273.png);
background-repeat:no-repeat;

}

.u_c_2BPC42.normal .popup-title{
font-size:0.43rem;
height:0.80rem;
background-size:100% 100%;
width:100%;
text-align:center;
padding-top:0.07rem;
box-sizing:border-box;
font-weight:600;

}

.u_c_2BPC42.normal .btn-bg{
display:flex;
margin:0 auto;
margin-top:0.27rem;
width:5.41rem;
height:1.07rem;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907414420753.png);
justify-content:center;
align-items:center;
background-repeat:no-repeat;

}

.u_c_2BPC42.normal .btn-txt{
color:#e6e6e6;
text-decoration:none;

}

.u_c_2BPC42.normal .commonFont{
font-size:0.33rem;

}

.u_c_2BPC42.normal .commonColor{
color:#2b2b2b;

}
}.default{
.u_c_YJD823.normal{
position:relative;
height:1.33rem;

}
}.default{
.u_c_IQ1I17.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_EY7P18.normal{
position:relative;
margin-top:0.48rem;

}
}.default{
.u_c_KR2M19.normal{
position:relative;
margin:auto;
margin-top:0.19rem;
text-align:center;

}

.u_c_KR2M19.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_KR2M19.normal .select-item-select{
background-size:100% 100%;
width:6.39rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907478112734.png);
font-size:0.29rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
background-color:unset;
background-repeat:no-repeat;

}
}.default{
.u_c_HZBH20.normal{
position:relative;

}
}.default{
.u_c_3SEO21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_Q6EH17.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_U10T18.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_YZGP19.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_X49T20.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_ZAYG21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_5SI923.normal{
position:relative;

}
}.default{
.u_c_2Y8024.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_330T25.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_6GFC37.normal{
position:relative;
margin:0 auto;
top:0.53rem;

}
}.default{
.u_c_TV8F38.normal{
position:absolute;
top:-0.23rem;
right:-0.04rem;

}
}.default{
.u_c_KN8R26.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_HQCT47.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}

.u_c_HQCT47.normal .border-color{
border:1px solid;
border-color:#bfb38d;

}
}.default{
.u_c_448359.normal{
position:relative;
margin-top:-0.05rem;

}
}.default{
.u_c_YEB860.normal{
position:relative;
height:5.67rem;
overflow-y:auto;
margin-top:0.08rem;

}
}.default{
.u_c_4G5M63.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_4G5M63.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;

}

.u_c_4G5M63.normal .th:last-child{
border-right:none;

}

.u_c_4G5M63.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_4G5M63.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_4G5M63.normal .txt-size{
word-break:break-word;

}

.u_c_4G5M63.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_0KSB65.normal{
position:relative;

}
}.default{
.u_c_TG2X67.normal{
position:relative;

}
}.default{
.u_c_UBST68.normal{
position:relative;

}
}.default{
.u_c_SQDF66.normal{
position:relative;

}
}.default{
.u_c_8TD969.normal{
position:relative;

}
}.default{
.u_c_ZEPA70.normal{
position:relative;
min-width:1.60rem;

}
}.default{
.u_c_ER8H71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_78XI64.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_TIZH62.normal{
position:absolute;
top:-0.04rem;
right:-0.07rem;

}
}.default{
.u_c_AFSS32.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_UBPO43.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_M1B344.normal{
position:relative;
margin-top:0.09rem;

}
}.default{
.u_c_G0FY45.normal{
position:relative;
box-sizing:border-box;
height:5.52rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:-0.09rem;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_3ZQY56.normal{
position:absolute;
top:-0.04rem;
right:-0.15rem;

}
}.default{
.u_c_C3H233.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_OX6L51.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;

}
}.default{
.u_c_C2JU42.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.51rem;
tex-align:center;
line-height:150%;

}
}.default{
.u_c_7C4L52.normal{
position:relative;
top:0.51rem;

}
}.default{
.u_c_1UF454.normal{
position:absolute;
top:-0.03rem;
right:0.09rem;

}
}.default{
.u_c_MMYF34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_P0BR79.normal{
position:relative;
width:2.67rem;
height:1.33rem;
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;

}
}.default{
.u_c_OXL080.normal{
position:relative;
margin-top:0.09rem;

}
}.default{
.u_c_Z9F820.normal{
position:relative;
top:1.41rem;

}
}.default{
.u_c_PNO584.normal{
position:absolute;
top:0;
right:0.12rem;

}
}.default{
.u_c_31P119.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_W90O20.normal{
position:relative;

}
}.default{
.u_c_15RV21.normal{
position:relative;
margin-top:0.68rem;

}
}.default{
.u_c_X5YO22.normal{
position:relative;
display:flex;
justify-content:center;
align-item:center;
width:100%;
margin-top:0.67rem;

}
}.default{
.u_c_YUS223.normal{
position:relative;
display:flex;
align-items:center;
font-size:0.40rem;

}
}.default{
.u_c_BG7F24.normal{
position:relative;
width:2.77rem;
height:0.99rem;
background-repeat:no-repeat;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.73rem;
text-decoration:underline !important;

}
}.default{
.u_c_W7PW25.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.default{
.u_c_1UN127.normal{
position:relative;
margin:0 auto;
top:0.40rem;

}
}.default{
.u_c_W8MW21.normal{
position:absolute;
top:-0.01rem;
right:0.09rem;

}
}.zh-TW{
.u_c_2BPC42.normal{
position:relative;

}

.u_c_2BPC42.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_2BPC42.normal .popup-content-small{
width:9.24rem;
height:7.13rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907467567971.png);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;
background-size:100% 100%;

}

.u_c_2BPC42.normal .popup-close{
width:0.67rem;
height:0.67rem;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907481944273.png);
background-repeat:no-repeat;

}

.u_c_2BPC42.normal .popup-title{
font-size:0.43rem;
height:0.80rem;
background-size:100% 100%;
width:100%;
text-align:center;
padding-top:0.07rem;
box-sizing:border-box;
font-weight:600;

}

.u_c_2BPC42.normal .btn-bg{
display:flex;
margin:0 auto;
margin-top:0.27rem;
width:5.41rem;
height:1.07rem;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907414420753.png);
justify-content:center;
align-items:center;
background-repeat:no-repeat;

}

.u_c_2BPC42.normal .btn-txt{
color:#e6e6e6;
text-decoration:none;

}

.u_c_2BPC42.normal .commonFont{
font-size:0.33rem;

}

.u_c_2BPC42.normal .commonColor{
color:#2b2b2b;

}
}.zh-TW{
.u_c_YJD823.normal{
position:relative;
height:1.33rem;

}
}.zh-TW{
.u_c_IQ1I17.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_EY7P18.normal{
position:relative;
margin-top:0.48rem;

}
}.zh-TW{
.u_c_KR2M19.normal{
position:relative;
margin:auto;
margin-top:0.19rem;
text-align:center;

}

.u_c_KR2M19.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_KR2M19.normal .select-item-select{
background-size:100% 100%;
width:6.39rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813907478112734.png);
font-size:0.29rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
background-color:unset;
background-repeat:no-repeat;

}
}.zh-TW{
.u_c_HZBH20.normal{
position:relative;

}
}.zh-TW{
.u_c_3SEO21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_Q6EH17.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_U10T18.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_YZGP19.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_X49T20.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_ZAYG21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_5SI923.normal{
position:relative;

}
}.zh-TW{
.u_c_2Y8024.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_330T25.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_6GFC37.normal{
position:relative;
margin:0 auto;
top:0.53rem;

}
}.zh-TW{
.u_c_TV8F38.normal{
position:absolute;
top:-0.23rem;
right:-0.04rem;

}
}.zh-TW{
.u_c_KN8R26.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_HQCT47.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}

.u_c_HQCT47.normal .border-color{
border:1px solid;
border-color:#bfb38d;

}
}.zh-TW{
.u_c_448359.normal{
position:relative;
margin-top:-0.05rem;

}
}.zh-TW{
.u_c_YEB860.normal{
position:relative;
height:5.67rem;
overflow-y:auto;
margin-top:0.08rem;

}
}.zh-TW{
.u_c_4G5M63.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_4G5M63.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;

}

.u_c_4G5M63.normal .th:last-child{
border-right:none;

}

.u_c_4G5M63.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_4G5M63.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_4G5M63.normal .txt-size{
word-break:break-word;

}

.u_c_4G5M63.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_0KSB65.normal{
position:relative;

}
}.zh-TW{
.u_c_TG2X67.normal{
position:relative;

}
}.zh-TW{
.u_c_UBST68.normal{
position:relative;

}
}.zh-TW{
.u_c_SQDF66.normal{
position:relative;

}
}.zh-TW{
.u_c_8TD969.normal{
position:relative;

}
}.zh-TW{
.u_c_ZEPA70.normal{
position:relative;
min-width:1.60rem;

}
}.zh-TW{
.u_c_ER8H71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_78XI64.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_TIZH62.normal{
position:absolute;
top:-0.04rem;
right:-0.07rem;

}
}.zh-TW{
.u_c_AFSS32.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_UBPO43.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_M1B344.normal{
position:relative;
margin-top:0.09rem;

}
}.zh-TW{
.u_c_G0FY45.normal{
position:relative;
box-sizing:border-box;
height:5.52rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:-0.09rem;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_3ZQY56.normal{
position:absolute;
top:-0.04rem;
right:-0.15rem;

}
}.zh-TW{
.u_c_C3H233.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_OX6L51.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;

}
}.zh-TW{
.u_c_C2JU42.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.51rem;
tex-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_7C4L52.normal{
position:relative;
top:0.51rem;

}
}.zh-TW{
.u_c_1UF454.normal{
position:absolute;
top:-0.03rem;
right:0.09rem;

}
}.zh-TW{
.u_c_MMYF34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_P0BR79.normal{
position:relative;
width:2.67rem;
height:1.33rem;
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;

}
}.zh-TW{
.u_c_OXL080.normal{
position:relative;
margin-top:0.09rem;

}
}.zh-TW{
.u_c_Z9F820.normal{
position:relative;
top:1.41rem;

}
}.zh-TW{
.u_c_PNO584.normal{
position:absolute;
top:0;
right:0.12rem;

}
}.zh-TW{
.u_c_31P119.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_W90O20.normal{
position:relative;

}
}.zh-TW{
.u_c_15RV21.normal{
position:relative;
margin-top:0.68rem;

}
}.zh-TW{
.u_c_X5YO22.normal{
position:relative;
display:flex;
justify-content:center;
align-item:center;
width:100%;
margin-top:0.67rem;

}
}.zh-TW{
.u_c_YUS223.normal{
position:relative;
display:flex;
align-items:center;
font-size:0.40rem;

}
}.zh-TW{
.u_c_BG7F24.normal{
position:relative;
width:2.77rem;
height:0.99rem;
background-repeat:no-repeat;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
margin-left:0.73rem;
text-decoration:underline !important;

}
}.zh-TW{
.u_c_W7PW25.normal{
position:relative;
text-align:center;
margin-top:0.40rem;

}
}.zh-TW{
.u_c_1UN127.normal{
position:relative;
margin:0 auto;
top:0.40rem;

}
}.zh-TW{
.u_c_W8MW21.normal{
position:absolute;
top:-0.01rem;
right:0.09rem;

}
}
</style>
